import React, { useState } from "react";
import PropTypes from "prop-types";

const ReportIssueConfirmationModal = ({ isOpen, onConfirm, onCancel, isLoading }) => {
  const [reason, setReason] = useState("");

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(reason);
    setReason("");
  };

  const handleCancel = () => {
    setReason("");
    onCancel();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full mx-4 p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Report an Issue</h2>

        <p className="text-sm text-gray-600 mb-4">
          Before reporting an issue, please contact our customer support team to try and resolve the matter amicably. Reporting an issue will put the booking under review and may delay the process.
        </p>

        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Please describe the issue in detail..."
          className="w-full p-3 border border-gray-200 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none mb-4"
          rows="4"
          disabled={isLoading}
        />

        <div className="flex gap-3">
          <button
            onClick={handleCancel}
            disabled={isLoading}
            className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-4 rounded-lg transition-all disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isLoading || !reason.trim()}
            className="flex-1 bg-red-500 hover:bg-red-600 text-white font-semibold py-3 px-4 rounded-lg transition-all disabled:opacity-50"
          >
            {isLoading ? "Reporting..." : "Report"}
          </button>
        </div>
      </div>
    </div>
  );
};

ReportIssueConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

ReportIssueConfirmationModal.defaultProps = {
  isLoading: false,
};

export default ReportIssueConfirmationModal;